<div *ngIf="show" class="formfield__errorMessage" tabindex="-1">
  {{ translateKey | translate }}
</div>
